import { fromJS } from 'immutable';
import { showGlobalSpinnerType, hideGlobalSpinnerType } from './GlobalSpinnerConstants';

export const initialState = fromJS({
  isShown: false,
  type: undefined,
});

// eslint-disable-next-line default-param-last
export default function globalSpinnerReducer(state = initialState, action) {
  switch (action.type) {
    case showGlobalSpinnerType: {
      return state.set('isShown', true).set('type', action.payload.type);
    }

    case hideGlobalSpinnerType: {
      return state.set('isShown', false).set('type', undefined);
    }

    default: {
      return state;
    }
  }
}
